import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import breakpoints from "../../../../assest/theme/base/breakpoints";
import PropTypes from "prop-types";
import { Fragment, useRef } from "react";
import MaterialBox from "../../../MaterialBox";


const SliderActions = ({ isNextItemAvailable, isPreviousItemAvailable, moveToNext, moveToPrevious }) => {

    //create a ref for next and previous button
    const nextButtonRef = useRef(null);
    const previousButtonRef = useRef(null);


    return (
        <Fragment>
            {
                isNextItemAvailable() && (

                    <MaterialBox
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: 10,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'transparent',
                            height: '100%',
                            width: window.innerWidth > breakpoints.values.md ? '10%' : '0px',
                            zIndex: 10,
                        }}
                        onMouseEnter={() => {
                            if (nextButtonRef && window.innerWidth > breakpoints.values.md) {
                                nextButtonRef.current.style.opacity = 1;
                            }
                        }}
                        onMouseLeave={() => {
                            if (nextButtonRef && window.innerWidth > breakpoints.values.md) {
                                nextButtonRef.current.style.opacity = window.innerWidth < breakpoints.values.md ? 0.5 : 0.1
                            }
                        }}
                    >
                        <MaterialBox
                            // Add the ref to the button
                            ref={nextButtonRef}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: 10,
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '10%',
                                width: '60px',
                                cursor: 'pointer',
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                ...window.innerWidth < breakpoints.values.md ? {
                                    opacity: 0.5,
                                } : {
                                    opacity: 0.1,
                                },
                                transition: 'opacity 0.5s',
                                borderRadius: '10px',
                            }}
                            {...((window.innerWidth > breakpoints.values.md) && {
                                onMouseEnter: (event) => {
                                    event.target.style.opacity = 1;
                                },
                                onMouseLeave: (event) => {
                                    event.target.style.opacity = 0.1;
                                },
                            })}
                            onClick={moveToNext}
                        >
                            <IconButton color="white" style={{ zIndex: 99 }}>
                                <ChevronRight fontSize="large" />
                            </IconButton>
                        </MaterialBox>
                    </MaterialBox>

                )
            }

            {
                isPreviousItemAvailable() && (
                    <MaterialBox
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: 10,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'transparent',
                            height: '100%',
                            width: window.innerWidth > breakpoints.values.md ? '10%' : '0px',
                            zIndex: 10,
                        }}
                        onMouseEnter={() => {
                            if (previousButtonRef && window.innerWidth > breakpoints.values.md) {
                                previousButtonRef.current.style.opacity = 1;
                            }
                        }}
                        onMouseLeave={() => {
                            if (previousButtonRef && window.innerWidth > breakpoints.values.md) {
                                previousButtonRef.current.style.opacity = window.innerWidth < breakpoints.values.md ? 0.5 : 0.1
                            }
                        }}
                    >
                        <MaterialBox
                            // Add the ref to the button
                            ref={previousButtonRef}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: 10,
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '10%',
                                width: '60px',
                                cursor: 'pointer',
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                ...window.innerWidth < breakpoints.values.md ? {
                                    opacity: 0.5,
                                } : {
                                    opacity: 0.1,
                                },
                                transition: 'opacity 0.5s',
                                borderRadius: '10px',
                            }}

                            {...((window.innerWidth > breakpoints.values.md) && {
                                onMouseEnter: (event) => {
                                    event.target.style.opacity = 1;
                                },
                                onMouseLeave: (event) => {
                                    event.target.style.opacity = 0.1;
                                },
                            })}
                            onClick={moveToPrevious}
                        >
                            <IconButton color="white">
                                <ChevronLeft fontSize="large" />
                            </IconButton>
                        </MaterialBox>
                    </MaterialBox>
                )
            }
        </Fragment >
    )
}

SliderActions.propTypes = {
    isNextItemAvailable: PropTypes.func.isRequired,
    isPreviousItemAvailable: PropTypes.func.isRequired,
    moveToNext: PropTypes.func.isRequired,
    moveToPrevious: PropTypes.func.isRequired,
}

SliderActions.defaultProps = {
    isNextItemAvailable: () => { },
    isPreviousItemAvailable: () => { },
    moveToNext: () => { },
    moveToPrevious: () => { },
}

export default SliderActions;